<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>

<template>
  <div class="footer-wrapper">
    <div class="footer-container">
      <div class="footer-logo">
        <a
          :href="t('new_customer.logo-link')"
          target="_blank"
          title="Lieferando"
          aria-label="Lieferando"
        >
          <img src="../assets/logo/logo_de_at.svg" alt="logo" />
        </a>
      </div>
      <div class="footer-links">
        <a :href="t('new_customer.footer.termsAndConditionsLink')">
          {{ t("new_customer.footer.termsAndConditions") }}
        </a>
        <a :href="t('new_customer.footer.privacyPolicyLink')">
          {{ t("new_customer.footer.privacyPolicy") }}
        </a>
      </div>
      <p>© 2025 Lieferando.de</p>
    </div>
  </div>
</template>

<style scoped>
.footer-wrapper {
  background-color: #ff8000;
}

.footer-container {
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  gap: 10px;
}

.footer-logo {
  max-width: 150px;
  max-height: 44px;
  margin-left: 20px;
}

.footer-logo img {
  width: 100%;
  height: auto;
}

.footer-links {
  display: flex;
  gap: 40px;
}

.footer-links a {
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: 18px;
  color: #fff;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-container p {
  color: white;
  font-size: 13px;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .footer-links a {
    font-size: 14px;
  }

  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .footer-logo {
    display: none;
  }
}
</style>
